const lazyload = (name) => (resolve) => require([`@/page/${name}`], resolve)
    // import personCenter from '@/page/personCenter'
const routes = [{
        path: '/loginCenter',
        name: '用户协议',
        component: lazyload('loginCenter'),
        meta: {
            title: '用户协议'
        }
    },
    {
        path: '/',
        redirect: '/home',
        component: lazyload('home'),
        meta: { title: '首页' },
        children: [{
            path: 'home',
            meta: { title: '首页' },
            component: lazyload('home')
        }]
    }, {
        path: '/findDept',
        component: lazyload('findDept'),
        meta: { title: '找科室' },
        children: [{
            path: 'findDept',
            meta: { title: '找科室' },
            component: lazyload('findDept')
        }]
    }, {
        path: '/findDoc',
        component: lazyload('findDoc'),
        meta: { title: '找名医' },
        children: [{
            path: 'findDoc',
            meta: { title: '找名医' },
            component: lazyload('findDoc')
        }]
    }, {
        path: '/fillInfor',
        component: lazyload('fillInfor'),
        meta: { title: '信息' },
        children: [{
            path: 'fillInfor',
            meta: { title: '信息' },

            component: lazyload('fillInfor')
        }]
    }, {
        path: '/personCenter',
        component: lazyload('personCenter'),
        name: 'personCenter',
        meta: { title: '个人中心' },

        children: [{
            path: 'menRecord',
            name: 'menRecord',
            meta: { title: '个人中心' },
            component: lazyload('menRecord')
        }, {
            path: 'menDetail',
            name: 'menDetail',
            meta: { title: '个人中心' },
            component: lazyload('menDetail')
        }, {
            path: 'patientList',
            name: 'patientList',
            meta: { title: '个人中心' },
            component: lazyload('patientList')
        }, {
            path: 'ysList',
            name: 'ysList',
            meta: { title: '个人中心' },
            component: lazyload('ysList')
        }, {
            path: 'changePwd',
            name: 'changePwd',
            meta: { title: '个人中心' },
            component: lazyload('changePwd')
        }]
    }, {
        path: '/helpnavlist',
        component: lazyload('helpnavlist'),
        meta: { title: '帮助中心' },

        name: 'helpnavlist',
        children: [{
            path: 'helpnavlist',
            name: 'helpnavlist',
            meta: { title: '帮助中心' },

            component: lazyload('helpnavlist')
        }]
    }, {
        path: '/addperson',
        component: lazyload('addperson'),
        meta: { title: '就诊人' },

        children: [{
            path: 'addperson',
            meta: { title: '就诊人' },

            component: lazyload('addperson')
        }]
    }, {
        path: '/alipayQrcode',
        component: lazyload('alipayQrcode'),
        meta: { title: '支付' },

        children: [{
            path: 'alipay',
            meta: { title: '支付' },
            component: lazyload('alipayQrcode')
        }]
    }, {
        path: '/alipayFinish',
        meta: { title: '支付' },
        component: lazyload('alipayFinish'),
        children: [{
            path: 'alipayFinish',
            meta: { title: '支付' },
            component: lazyload('alipayFinish')
        }]
    }, {
        path: '/alipayStatus',
        component: lazyload('alipayStatus'),
        meta: { title: '支付' },

        children: [{
            path: 'alipayStatus',
            meta: { title: '支付' },
            component: lazyload('alipayStatus')
        }]
    }, {
        path: '/waitpay',
        component: lazyload('waitpay'),
        meta: { title: '等待支付' },

        children: [{
            path: 'waitpay',
            meta: { title: '等待支付' },
            component: lazyload('waitpay')
        }]
    }, {
        path: '/menDetail',
        component: lazyload('menDetail'),
        name: 'menDetail',
        meta: { title: '支付成功' },

        children: [{
            path: 'menDetail',
            name: 'menDetail',
            meta: { title: '支付成功' },
            component: lazyload('menDetail')
        }]
    }, {
        path: '/twzx',
        component: lazyload('twzx'),
        meta: { title: '图文咨询' },

        children: [{
            path: 'twzx',
            name: 'twzx',
            meta: { title: '图文咨询' },
            component: lazyload('twzx')
        }]

    }
]
export {
    routes
}


// WEBPACK FOOTER //
// ./src/router/routes.js